import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Shield } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div 
        data-testid="protected-route-loading"
        className="min-h-screen bg-[#0A0A0A] flex flex-col justify-center items-center text-white font-sans"
      >
        <div className="text-center space-y-4">
          <div className="mx-auto w-12 h-12 bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] border border-[#D4AF37]/20 animate-spin">
            <Shield size={24} />
          </div>
          <p className="text-xs uppercase tracking-[0.3em] text-white/50">
            Verificare acces securizat...
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
